<template>
  <v-app id="national-registry-app">
    <pc-singleton-modals
      id="singleton-national-registry-modals"
    ></pc-singleton-modals>
    <pc-singleton-overlay
      id="singleton-national-registry-overlay"
    ></pc-singleton-overlay>
    <pc-singleton-snackbar
      id="singleton-national-registry-snackbar"
    ></pc-singleton-snackbar>

    <div v-if="initialAuthenticationRequestComplete" class="fill-height">
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
import notifyPendo from "@/shared/lib/notifyPendo";
import { getClientPortalLoginUrl } from "@/shared/lib/client-portal-handoff";

export default {
  components: {},

  data: () => ({
    initialAuthenticationRequestComplete: false,
  }),

  methods: {},

  mounted: function () {
    if (
      window.amplifyRuntimeConfig.get("VUE_APP_ENVIRONMENT") === "production"
    ) {
      var script = document.createElement("script");
      script.setAttribute(
        "src",
        "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      );
      script.setAttribute("type", "text/javascript");
      script.setAttribute("charset", "UTF-8");
      script.setAttribute(
        "data-domain-script",
        "be7a220f-98ff-43a3-9601-e26f94afee55"
      );
      document.head.appendChild(script);
    }

    // Initalize with the progress overlay
    this.$overlay.show("Loading...");

    // Refresh authenticated user.
    this.$store.dispatch(
      "refreshNationalRegistryAuthenticatedUser",
      function (user) {
        if (user && user.isStaffMember()) {
          document.location = window.amplifyRuntimeConfig.get(
            "VUE_APP_ADMIN_BASE_URL"
          );
        } else if (user && user.isClient()) {
          document.location = getClientPortalLoginUrl(
            window.amplifyRuntimeConfig
          );
        } else if (user && user.isParticipant()) {
          document.location = window.amplifyRuntimeConfig.get(
            "VUE_APP_PARTICIPANT_BASE_URL"
          );
        } else {
          this.$overlay.hide();
          this.initialAuthenticationRequestComplete = true;
          notifyPendo(user);
        }
      }.bind(this)
    );

    const favicon = document.getElementById("favicon");
    favicon.href =
      window.amplifyRuntimeConfig.get("VUE_APP_NATIONAL_REGISTRY_BASE_URL") +
      "/national-registry-favicon.ico";
  },
};
</script>

<style lang="scss">
#national-registry-app.v-application {
  font-family: "Roboto", sans-serif;

  body,
  p {
    color: $penChecksDarkGray;
  }

  h1 {
    font-size: 22px;
    font-weight: 400;
    color: $penChecksNavyBlue;
  }

  h2 {
    font-size: 18px;
    font-weight: 400;
    color: $penChecksDarkTeal;
  }

  h3 {
    font-size: 20px;
    font-weight: 500;
    color: $penChecksGreen;
  }

  a {
    color: $penChecksTeal;
    text-decoration: none;
  }

  a.upper {
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    color: $penChecksDarkTeal;
  }

  .text-small {
    font-size: 12px;
    color: $penChecksMediumGray;
  }

  .text-medium {
    font-size: 14px;
    color: $penChecksMediumGray;
  }

  .text-question {
    font-size: 18px;
    font-weight: 500;
    color: $penChecksDarkTeal;
    padding-bottom: 0;
  }

  .text-x-large {
    font-size: 36px;
    font-weight: 500;
    color: $penChecksDarkGray;
  }

  .text-x-semi-large {
    font-size: 24px;
    font-weight: 500;
    color: $penChecksDarkGray;
  }

  .founds-caption {
    font-size: 14px !important;
  }

  .text-currency-header {
    font-size: 20px;
    font-weight: 500;
    color: $penChecksDarkGray;
  }

  .text-currency-header-blue {
    font-size: 20px;
    font-weight: 500;
    color: $penChecksDarkTeal;
  }

  .text-currency-medium {
    font-size: 16px;
    font-weight: 500;
  }

  .text-header-medium {
    font-size: 16px;
    font-weight: 500;
    color: $penChecksDarkGray;
  }

  .text-header-blue-medium {
    font-size: 18px;
    font-weight: 500;
    color: $penChecksDarkTeal;
  }

  .text-header-blue16-medium {
    font-size: 16px;
    font-weight: 500;
    color: $penChecksDarkTeal;
  }

  .text-header-regular {
    font-size: 20px;
    font-weight: 400;
    color: $penChecksDarkGray;
  }

  .text-regular-16 {
    font-size: 16px;
    font-weight: 400;
    color: $penChecksDarkGray;
  }

  .text-regular-14 {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: $penChecksDarkGray;
  }

  .text-regular-12 {
    font-size: 12px;
    font-weight: 400;
    color: $penChecksDarkGray;
  }

  .text-concat {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text-home-image {
    font-size: 20px;
    font-weight: 500;
    margin: 24px;
    color: $penChecksOrange;
  }

  // Vuetify v2.4 changed styling for nested grid items, causing spacing across the
  // app to be affected. A solution was found here that restores our previous spacing:
  // https://github.com/vuetifyjs/vuetify/issues/12848
  .row {
    margin-top: 0;
    margin-bottom: 0;
  }

  .row + .row {
    margin-top: 0;
  }
}
</style>
